type NamedKnowledgeBase = {
  id: string;
  name: string;
};

export type PlatformChatKnowledgeBaseOption = {
  id: string;
  name: string;
  isLinked: boolean;
};

export function buildPlatformChatKnowledgeBaseOptions(
  knowledgeBases: NamedKnowledgeBase[] | undefined,
  linkedKnowledgeBaseByKnowledgeBaseId: Map<string, string>,
  locale: string,
): PlatformChatKnowledgeBaseOption[] {
  const options = (knowledgeBases ?? []).map((knowledgeBase) => ({
    id: knowledgeBase.id,
    name: knowledgeBase.name,
    isLinked: linkedKnowledgeBaseByKnowledgeBaseId.has(knowledgeBase.id),
  }));

  return options.sort((left, right) => {
    if (left.isLinked !== right.isLinked) {
      return left.isLinked ? -1 : 1;
    }
    return left.name.localeCompare(right.name, locale, {
      sensitivity: 'base',
    });
  });
}

export function buildDocumentPreviewKnowledgeBases(
  knowledgeBases: NamedKnowledgeBase[] | undefined,
): Array<{ id: string; name: string }> | undefined {
  if (knowledgeBases == null) {
    return undefined;
  }

  return knowledgeBases.map((knowledgeBase) => ({
    id: knowledgeBase.id,
    name: knowledgeBase.name,
  }));
}

export function resolveFallbackKnowledgeBaseId(
  linkedKnowledgeBases: ReadonlyArray<{ knowledgeBaseId: string }> | undefined,
): string | undefined {
  const linked = linkedKnowledgeBases ?? [];
  if (linked.length === 1) {
    return linked[0]?.knowledgeBaseId;
  }
  return undefined;
}

export function resolveWelcomeFirstName(options: {
  profileFirstName: string | undefined;
  directoryFirstName: string | undefined;
  displayNameFirstName: string | undefined;
}): string {
  return (
    options.profileFirstName ||
    options.directoryFirstName ||
    options.displayNameFirstName ||
    ''
  );
}
